export const HandleRoutesNavigation = ({
  show,
  edit,
  isEditable,
  isEditableAfterPost,
  editableAfterPost,
}: {
  show: string;
  edit: string;
  editableAfterPost?: string;
  isEditable: boolean;
  isEditableAfterPost?: boolean;
}) => {
  return isEditable
    ? isEditableAfterPost && editableAfterPost
      ? editableAfterPost
      : edit
    : show;
};
